import React from "react";
import RadioSection from "./RadioSection/RadioSection";
import { Field } from "../../../Interface/scheduler/form";
import { AppConstants } from "../../../constants/constant";
import CleaningRadioSection from "./CleaningRadioGroup/CleaningRadioSection";
import { SUSPENSE_WRAPPER } from "../SuspenseWrapper/SuspenseWrapper";
const LazyRenderPriceQuoteRadioSection = React.lazy(
  () =>
    import(
      /* webpackChunkName: "scheduler/ServicePage" */ "./PriceQuoteRadioSection/PriceQuoteRadioSection"
    ),
);
const LazyRenderStackedRadioSection = React.lazy(
  () =>
    import(
      /* webpackChunkName: "scheduler/ServicePage" */ "./StackedRadioSection/StackedRadioSection"
    ),
);

interface RadioGroupHandlerProps {
  field: Field;
  error: string | null | undefined;
  handleFunction: (event: React.ChangeEvent<HTMLInputElement>) => void;
  errors: { [key: string]: string };
  setErrors?: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
}

const RadioGroupHandler: React.FC<RadioGroupHandlerProps> = ({
  field,
  error,
  handleFunction,
  errors,
  setErrors,
}) => {
  const props = { field, error, handleFunction, errors, setErrors };
  if (field.id === AppConstants.FIELD_ID_PRICE_QUOTE_SELECTION) {
    return SUSPENSE_WRAPPER(
      <LazyRenderPriceQuoteRadioSection {...props} />,
      "cards",
    );
  }

  if (
    field.id === AppConstants.FIELD_ID_CAR_SERVICE_SELECTION ||
    field.id === AppConstants.PAYMENT_ID_SELECTION ||
    field.id === AppConstants.MOBILE_ID_SELECTION
  ) {
    return SUSPENSE_WRAPPER(
      <LazyRenderStackedRadioSection {...props} />,
      "cards",
    );
  }

  if (field?.isCleaningRadioGroup) return <CleaningRadioSection {...props} />;

  return <RadioSection {...props} />;
};

export default RadioGroupHandler;
